
import { useToken } from "./token_context";
import { usePageContext } from "./page_context";
import * as React from 'react';

import { CreateNewDataBaseAction } from "./create_new_database_modal";

function noop() { alert("no operation!") };

export function BottomButtons() {
    const {token} = useToken();
    const { page_state, setPageState} = usePageContext();

    const AddTokenAction = () => {
        setPageState({
            admin_tokens_active: true,
            edit_token_dialog_open: true,
            edit_token_id: null
        });
    };

    const EditParametersAction = () => {
        setPageState({
            edit_parameters_dialog_open: true
        });
    };

    const AdminTokensAction = () => {
        setPageState({
            admin_tokens_active: true
        });
    };

    const SubmitSessionAction = () => {
        setPageState({
            submit_session_active: true
        });
    };

    var action_count = 0
    var the_action;
    var init_db_button, edit_parameters_button, edit_tokens_button, add_session_button, add_access_token_button;
    if (token.permissions.includes("can_init_db")) {
        init_db_button = <button onClick={ CreateNewDataBaseAction } className="btn btn-sm btn-secondary mx-2"> Create new Database </button>
        action_count ++;
        the_action = CreateNewDataBaseAction;
    };

    if (token.permissions.includes("can_edit_parameters")) {
        edit_parameters_button = <button onClick={ EditParametersAction } className="btn btn-sm btn-primary mx-2"> Edit Parameters </button>
        action_count ++;
        the_action = EditParametersAction;
    };

    if (token.permissions.includes("can_admin_tokens")) {
        edit_tokens_button = <button onClick={ AdminTokensAction } className="btn btn-sm btn-primary mx-2"> Admin Tokens </button>
        action_count ++;
        the_action = AdminTokensAction;
    };

    if (token.permissions.includes("can_submit_session")) {
        add_session_button = <button onClick={ SubmitSessionAction } className="btn btn-sm btn-primary mx-2"> Pitch Session </button>
        action_count ++;
        the_action = SubmitSessionAction;
    };

    if (token.permissions.includes("can_admin_tokens")) {
        if (page_state.admin_tokens_active) {
            add_access_token_button = <button onClick={ AddTokenAction } className="btn btn-sm btn-primary mx-2"> + Add Access Token </button>
        };
    };

    if (action_count == 1) {
        setTimeout(the_action, 500);
        init_db_button = edit_parameters_button = edit_tokens_button = add_session_button = add_access_token_button = "";
    };

    return (<>
            <div className="float-left">
                {init_db_button}
                {edit_tokens_button}
                {edit_parameters_button}
                {add_session_button}
            </div>
            <div className="float-right">
                {add_access_token_button}
            </div>
    </>);
};
